export default __webpack_public_path__ + "static/blob3-41835fad2bebf383a81b08d57036b38b.svg";